import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'mom-form-field-verification-code',
  templateUrl: 'form-field-verification-code.component.html',
  styleUrls: ['./form-field-verification-code.component.scss']
})
export class FormFieldVerificationCodeComponent implements OnInit {
  @Input() invalid: boolean;
  @Output() verify = new EventEmitter<string>();

  ctrl = new UntypedFormControl(null, Validators.required);

  private verificationCodeLength = 6;

  @Input() set smsValue(value: string) {
    if (!value) {
      return;
    }
    this.ctrl.setValue(value);
  }

  ngOnInit(): void {
    this.ctrl.valueChanges.subscribe(() => {
      if (this.ctrl.value.length === this.verificationCodeLength) {
        this.verify.emit(this.ctrl.value);
      }
    });
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');

    if (pastedText.length !== this.verificationCodeLength) {
      return;
    }

    this.ctrl.patchValue(pastedText);
  }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;

    if (!target || target.maxLength !== target.value.length) {
      return;
    }

    const { nextElementSibling } = target;

    if (nextElementSibling) {
      (nextElementSibling as HTMLInputElement).focus();
    }
  }

  onBackspace(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      target.value = '';
      return;
    }
    const { previousElementSibling } = target;
    if (previousElementSibling) {
      (previousElementSibling as HTMLInputElement).focus();
    }
  }
}
